// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BookFilledSvg from "@fishx/icons-svg/es/asn/BookFilled";
import FishxIcon from '../components/FishxIcon';

var BookFilled = function BookFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BookFilledSvg
  }));
};

BookFilled.displayName = 'BookFilled';
export default React.forwardRef(BookFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BookFilled.js
// module id = 2079
// module chunks = 0